import styled, { keyframes } from 'styled-components';
import { px2rem } from '../utils/helpers/style.js';
import { boxStyles } from '../Box/styles.js';
import { boxStyledOptions } from '../utils/helpers/styled.js';
import { styledContentText } from '../ContentText/styles.web.js';
import { styles } from '../constants/styles.js';
import { spacing } from '../constants/spacing.js';
import { timings } from '../constants/timings.js';

var FileUploadBorder = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__FileUploadBorder",
  componentId: "sc-29knsg-0"
})(["width:100%;height:100%;position:absolute;transition:background-image ", ";transition-timing-function:", ";background-image:linear-gradient(to right,", " 50%,transparent 50%),linear-gradient(to right,", " 50%,transparent 50%),linear-gradient(to bottom,", " 50%,transparent 50%),linear-gradient(to bottom,", " 50%,transparent 50%);background-position:left top,left bottom,left top,right top;background-repeat:repeat-x,repeat-x,repeat-y,repeat-y;background-size:16px 2px,16px 2px,2px 16px,2px 16px;"], styles.transition.timing.slowest, styles.transition["function"].base, function (p) {
  return p.$borderColor;
}, function (p) {
  return p.$borderColor;
}, function (p) {
  return p.$borderColor;
}, function (p) {
  return p.$borderColor;
});
var FileUploadAreaContainer = /*#__PURE__*/styled.div.withConfig(boxStyledOptions).withConfig({
  displayName: "styles__FileUploadAreaContainer",
  componentId: "sc-29knsg-1"
})(["width:", ";overflow-x:hidden;padding:", " 0 ", " 0;", ";"], function (p) {
  return p.width || p.theme.fileUpload.web.width;
}, spacing.xxxs, spacing.xxs, boxStyles);
var FileDropzoneContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__FileDropzoneContainer",
  componentId: "sc-29knsg-2"
})(["width:", ";height:", ";position:relative;box-sizing:border-box;transition:background-color ", ";transition-timing-function:", ";background-color:", ";&:hover{cursor:", ";background-color:", ";}&:focus-visible{box-shadow:inset 0 0 0 2px ", ",inset 0 0 0 4px ", ";outline:none;", "{display:none;}}:focus{background:", ";}"], function (p) {
  return p.$width || p.theme.fileUpload.web.width;
}, function (p) {
  return p.$height || p.theme.fileUpload.web.height;
}, styles.transition.timing.fastest, styles.transition["function"].base, function (p) {
  if (!(p.$isFocused || p.$isDragActive || p.$isDragAccept)) {
    return;
  }
  return p.theme.fileUpload.web.backgroundSecondary;
}, function (p) {
  return p.$disabled || p.$isInvalid ? 'not-allowed' : !p.$uploading ? 'pointer' : undefined;
}, function (p) {
  return !(p.$disabled || p.$uploading) && p.theme.fileUpload.web.backgroundSecondary;
}, function (p) {
  return p.theme.tokens.focus.primary;
}, function (p) {
  return p.theme.tokens.focus.secondary;
}, FileUploadBorder, function (p) {
  return p.theme.fileUpload.web.backgroundSecondary;
});
var FileUploadContent = /*#__PURE__*/styled.div.withConfig(boxStyledOptions).withConfig({
  displayName: "styles__FileUploadContent",
  componentId: "sc-29knsg-3"
})(["width:100%;height:100%;max-width:100%;max-height:100%;box-sizing:border-box;padding:", ";position:absolute;input{display:none;}", ";"], spacing.xxs, boxStyles);
var FileList = /*#__PURE__*/styled.ul.withConfig({
  displayName: "styles__FileList",
  componentId: "sc-29knsg-4"
})(["padding:0;li{margin-bottom:", ";}li:last-child{margin-bottom:0;}"], spacing.xxxs);
var inAnimation = /*#__PURE__*/keyframes(["0%{animation-timing-function:ease-in;opacity:0;height:0;}100%{opacity:1;height:", ";}"], px2rem(64));
var successAnimation = /*#__PURE__*/keyframes(["0%{animation-timing-function:ease-in;opacity:0;}25%{opacity:1;}75%{opacity:1;}100%{opacity:0;}"]);
var enterAnimation = /*#__PURE__*/keyframes(["0%{animation-timing-function:ease-in;opacity:0;}20%{opacity:1;}100%{opacity:1;}"]);
var AnimatedIconSwap = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__AnimatedIconSwap",
  componentId: "sc-29knsg-5"
})(["position:relative;width:40px;height:40px;> :first-child,> :last-child{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);}> :first-child{opacity:0;animation:", " ", "ms forwards;animation-iteration-count:1;}> :last-child{opacity:0;animation:", " ", " forwards;animation-iteration-count:1;animation-delay:", "ms;}"], successAnimation, timings.base * 5, enterAnimation, styles.transition.timing.base, timings.base * 5);
var FileListItem = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__FileListItem",
  componentId: "sc-29knsg-6"
})(["display:flex;align-items:center;height:64px;background-color:", ";border-radius:", ";border:", ";padding:0 ", " 0 ", ";animation:", " ", " forwards;&:focus-visible{box-shadow:inset 0 0 0 2px ", ",inset 0 0 0 4px ", ";outline:none;}"], function (p) {
  return p.theme.fileUpload.web.listItem.background;
}, function (p) {
  return p.theme.borders.radius;
}, function (p) {
  return p.$hasError && "2px solid ".concat(p.theme.colors.alert);
}, spacing.xxxs, spacing.xxs, inAnimation, styles.transition.timing.base, function (p) {
  return p.theme.tokens.focus.primary;
}, function (p) {
  return p.theme.tokens.focus.secondary;
});
var ContentContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__ContentContainer",
  componentId: "sc-29knsg-7"
})(["display:flex;align-content:center;flex-direction:column;flex:1;overflow:hidden;padding-left:", ";padding-right:", ";", "{text-overflow:ellipsis;white-space:nowrap;overflow:hidden;margin:0;}"], px2rem(spacing.xxxs), px2rem(spacing.xxxs), styledContentText);

export { AnimatedIconSwap, ContentContainer, FileDropzoneContainer, FileList, FileListItem, FileUploadAreaContainer, FileUploadBorder, FileUploadContent };
